/* tslint:disable */
/* eslint-disable */
/**
 * K1 OpenAPI
 * API fuer die Nutzung der K1 REST-Schnittstelle
 *
 * The version of the OpenAPI document: 1.168.0-SNAPSHOT
 * Contact: diplan-backend@init.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ErrorRest } from '../models';
// @ts-ignore
import type { StammdatenRest } from '../models';
/**
 * KontaktResourceApi - axios parameter creator
 * @export
 */
export const KontaktResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden alle Kontakte (Kontakte.xml) ausgeliefert.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
         * @summary Endpunkt der alle Kontakte ausliefert.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllKontakte: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/konfigurationen/kontakte`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird die kontakte.xml hochgeladen.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
         * @summary Endpunkt zum Hochladen von Kontakten.
         * @param {File} kontakte Kontakte Xml-Datei
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadKontakte: async (kontakte: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'kontakte' is not null or undefined
            assertParamExists('uploadKontakte', 'kontakte', kontakte)
            const localVarPath = `/konfigurationen/kontakte`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (kontakte !== undefined) { 
                localVarFormParams.append('kontakte', kontakte as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * KontaktResourceApi - functional programming interface
 * @export
 */
export const KontaktResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = KontaktResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden alle Kontakte (Kontakte.xml) ausgeliefert.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
         * @summary Endpunkt der alle Kontakte ausliefert.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllKontakte(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllKontakte(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KontaktResourceApi.getAllKontakte']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird die kontakte.xml hochgeladen.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
         * @summary Endpunkt zum Hochladen von Kontakten.
         * @param {File} kontakte Kontakte Xml-Datei
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadKontakte(kontakte: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StammdatenRest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadKontakte(kontakte, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KontaktResourceApi.uploadKontakte']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * KontaktResourceApi - factory interface
 * @export
 */
export const KontaktResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = KontaktResourceApiFp(configuration)
    return {
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden alle Kontakte (Kontakte.xml) ausgeliefert.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
         * @summary Endpunkt der alle Kontakte ausliefert.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllKontakte(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getAllKontakte(options).then((request) => request(axios, basePath));
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird die kontakte.xml hochgeladen.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
         * @summary Endpunkt zum Hochladen von Kontakten.
         * @param {File} kontakte Kontakte Xml-Datei
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadKontakte(kontakte: File, options?: RawAxiosRequestConfig): AxiosPromise<StammdatenRest> {
            return localVarFp.uploadKontakte(kontakte, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * KontaktResourceApi - object-oriented interface
 * @export
 * @class KontaktResourceApi
 * @extends {BaseAPI}
 */
export class KontaktResourceApi extends BaseAPI {
    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden alle Kontakte (Kontakte.xml) ausgeliefert.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
     * @summary Endpunkt der alle Kontakte ausliefert.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KontaktResourceApi
     */
    public getAllKontakte(options?: RawAxiosRequestConfig) {
        return KontaktResourceApiFp(this.configuration).getAllKontakte(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird die kontakte.xml hochgeladen.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
     * @summary Endpunkt zum Hochladen von Kontakten.
     * @param {File} kontakte Kontakte Xml-Datei
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KontaktResourceApi
     */
    public uploadKontakte(kontakte: File, options?: RawAxiosRequestConfig) {
        return KontaktResourceApiFp(this.configuration).uploadKontakte(kontakte, options).then((request) => request(this.axios, this.basePath));
    }
}

